import { axiosGet, axiosPost } from "../../react_axios/Axios"
import {

    countDownDateUrl,
    COUNT_DOWN_DATE_ACTION,
    GET_WEBSITE_BLOG_LIST_ACTION,
    getWebsiteBlogListUrl,
    getWebsiteBlogDetailsUrl,
    getStaticMemberListUrl,
    GET_STATIC_MEMBER_LIST_ACTION
} from "../../utils/constants"

export const countDownDate_action = () => async (dispatch) => {
    const mapdata = {}
    try {
        const res = await axiosGet(countDownDateUrl, mapdata);

        dispatch({
            type: COUNT_DOWN_DATE_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getWebsiteBlogList_action = () => async (dispatch) => {
    const mapdata = {}
    try {
        const res = await axiosGet(getWebsiteBlogListUrl, mapdata);

        dispatch({
            type: GET_WEBSITE_BLOG_LIST_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getWebsiteBlogDetails_action = (BlogID) => async (dispatch) => {
    const mapdata = { BlogID: BlogID }
    try {
        const res = await axiosGet(getWebsiteBlogDetailsUrl, mapdata);

        dispatch({
            type: GET_WEBSITE_BLOG_LIST_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getStaticMemberList_action = () => async (dispatch) => {
    const mapdata = {}
    try {
        const res = await axiosGet(getStaticMemberListUrl, mapdata);

        dispatch({
            type: GET_STATIC_MEMBER_LIST_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};